import { render, staticRenderFns } from "./Pc.vue?vue&type=template&id=261b1739&scoped=true&"
import script from "./Pc.vue?vue&type=script&lang=js&"
export * from "./Pc.vue?vue&type=script&lang=js&"
import style0 from "./Pc.vue?vue&type=style&index=0&id=261b1739&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261b1739",
  null
  
)

export default component.exports